export default "__VITE_ASSET__2797ea6c__"